const Reflux = require('@muzzylane/reflux');

const ShortCourseEditorActions = Reflux.createActions([
    "initializeEditorDoc",          // (actionId,doc,activities) doc parameter = the short course doc from the server
    "updateActivityVersion",        // (actionId,nova_activity_id,version)
    "addPrereq",                    // (actionId,node_id,prereq_id)
    "removePrereq",                 // (actionId,node_id,prereq_id)
    "setNodePosition",              // (actionId,node_id, position)
    "addSkillNode",                 // (actionId,capstone:false) newNodeId is generated for the action
    "deleteSkillNode",              // (actionId, node_id) 
    "selectNode",                   // (actionId, node_id)
    "setNodeValue",                 // (actionId, node_id, key, value) for simple node values (name, description etc) 
    "setNodeRSD",                   // (actionId, params {node_id, rsd_service_id, rsd_id})  
    "addContentBlock",        		// (actionId, params: {nova_activity_id, activity_version, score_categories} ) 
    "removeContentBlock",   		// (actionId, nova_activity_id) 
    "addContentBlockToNode",        // (actionId, params: {node_id, nova_activity_id, activity_version, score_categories} ) 
    "removeContentBlockFromNode",   // (actionId, node_id, nova_activity_id) 
    "setContentBlockValue",     	// (actionId, params:{nova_activity_id,key,value})
    "setContentBlockNodeValue",     // (actionId, params:{node_id,nova_activity_id,key,value})
    "addChatbotContentBlock",       // (actionId, params: {node_id, display_title, chat_activity_hash, activity_type, subskill_relations, bot_options} ) 
    "updateChatbotContentBlock",    // (actionId, params: {chat_activity_hash, display_title, activity_type, subskill_relations, bot_options} ) 
    "removeChatbotContentBlock",    // (actionId, chat_activity_id) 
    "addSubskill",            		// (actionId) new_ss_hash is generated for the action
    "deleteSubskill",       		// (actionId, ss_hash)
    "addSubskillToNode",            // (actionId, node_id) new_ss_hash is generated for the action
    "deleteSubskillFromNode",       // (actionId, node_id, ss_hash)
    "setSubskillValue",             // (actionId, node_id, ss_hash, key, value) 
    "setContentBlockSubskillValue", // (actionId, params: {ss_hash, nova_activity_id, key, value}
    "syncContentBlockSubskills",    // (actionId, params: {nova_activity_id}
    "addCoachRichText",             // (actionId, coach_script_id, rich_text_id, displayName) // params after actionId are optional
    "deleteCoachRichText",          // (actionId, rich_text_id)
    "setRichText",                  // (actionId, rich_text_id, richText)
    "setRichTextTitle",             // (actionId, rich_text_id, displayName)
    "setBackground",                // (actionId, src)
    "addSticker",                   // (actionId, coach_sticker_id, displayName) // coach_sticker_id and displayName are optional
    "setStickerSrc",                // (actionId, coach_sticker_id, src)
    "setStickerDisplayName",        // (actionId, coach_sticker_id, displayName)
    "deleteSticker",                // (actionId, coach_sticker_id)
    "setMasteryScore",              // (actionId, masteryScore)
    "setPerfectScore",              // (actionId, perfectScore)
    "setTutorialScoreA2",           // (actionId, tutorialScoreA2)
    "setTutorialScoreA3",           // (actionId, tutorialScoreA3)
    "setBadgeParameters",           // (actionId, badge_parameters)
    "updateCoachScriptAction",      // (actionId, coachScriptId, actionIndex, changes)
    "addCoachScriptAction",         // (actionId, coachScriptId)
    "moveCoachScriptAction",        // (actionId, coachScriptId, actionIndex, delta)
    "deleteCoachScriptAction",      // (actionId, coachScriptId, actionIndex)
    "changeCriteriaScoresStyle",    // (actionId, params: {key, value})
    "changeVoiceOptions",           // (actionId, options)
    "changeCourseCardOptions",      // (actionId, options)
    "changePhraseData",             // (actionId, phraseData)
    "setDocBoilerplate",            // (actionId, id, value)
    "importClientContent",          // (actionId, changes)
    
    // for sidebars
    "setCurrentNavLoc",             // (navLoc) - sets currentNav for future use (such as by an add comment button)
    "goToLocation",                 // (navLoc) - goes to a nav location
    "setSelectedCommentTopic",      // (id)
    "setNodeSearch",                // (searchText)

]);


// no need for actions (all handled by store)

module.exports = ShortCourseEditorActions;